'use-client';
import * as React from 'react';
import classNames from 'clsx';
import { getDataAttributes } from '@wix/editor-elements-common-utils';
import type { ItunesButtonProps } from '../ItunesButton.types';
import Link from '../../Link/viewer/Link';
import style from './style/ItunesButton.scss';
import { translations as constTranslations, image } from './constants';
import type { ItunesLanguages } from '../documentManagement/ItunesButton.schemaTypes';

const normalizeLanguage = (language: ItunesLanguages) => {
  if (language === 'ja') {
    return 'JP'; // ja is correct according to ISO 639-1 (Wix uses it), but iTunes URL expects ISO 3166-1 (JP)
  }

  return language.toUpperCase();
};

const ItunesButton: React.FC<ItunesButtonProps> = props => {
  const {
    id,
    className,
    language = 'en',
    link = {},
    reportBiOnClick,
    translations,
  } = props;
  const imageUrl = image.URL.replace(
    image.languagePlaceholder,
    normalizeLanguage(language),
  );

  const onClick = () => {
    reportBiOnClick(imageUrl, translations.ariaLabel!);
  };

  return (
    <div
      id={id}
      {...getDataAttributes(props)}
      className={classNames(style.root, className)}
      title={constTranslations.ARIA_LABEL_DEFAULT}
      onClick={onClick}
    >
      <Link
        className={style.link}
        {...link}
        aria-label={translations.ariaLabel}
      >
        <img className={style.img} src={imageUrl} alt="" />
      </Link>
    </div>
  );
};

export default ItunesButton;
